export enum FrontViewerRingStatus {
    NotStarted = 0,
    Drilling = 1,
    Drilled = 2,
    Charging = 3,
    Charged = 4,
    Fired = 5,
    Bogging = 6,
    Bogged = 7,
}